import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	manageAccount: {
		defaultMessage: 'Manage account',
		id: 'atlassian-navigation.profile.menu.account-details.manage-account',
		description: 'Menu item link to manage account page',
	},
});
